<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractServiceFees"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    :name="gridName"
    :headerTitle="'Contract service fees'|pgettext('ContractServiceFees')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'contract-service-fees'|pgettext('filename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="mx-2"
      >
        <ItpFormCheckbox
          name="skip_archived"
          :label="'Skip archived items'|pgettext('ContractServiceFees')"
          inline
          v-model="dsParams.skip_archived"
        >
        </ItpFormCheckbox>
      </DIV>
      <DIV
        class="border-left px-4"
      >
        <ItpButton
          :disabled="!selectedItems || !selectedItems.length"
          :icon="$config.contract.createContractIcon"
          :text="'Bulk edit...'|pgettext('ContractServiceFees')"
          size="sm"
          variant="light"
          @click="evh_4440454779651433_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :disabled="!selectedItems || !selectedItems.length"
          :icon="$config.deleteIcon"
          :text="'Delete'|pgettext('ContractServiceFees')"
          :title="'Delete the selected items'|pgettext('ContractServiceFees')"
          size="sm"
          variant="light"
          :spinning="actions.bulkDelete.isRunning"
          class="ml-2"
          @click="evh_8643180786190723_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          :disabled="!selectedItems || !selectedItems.length"
          :icon="$config.priceIndexingIcon"
          :text="'Indexing...'|pgettext('ContractServiceFees')"
          size="sm"
          variant="light"
          class="ml-2"
          @click="evh_2996188254223402_click($event, {})"
        >
        </ItpButton>
      </DIV>
      <PageHelp
        path="/contracts/contracts.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "ContractServiceFees",
    path: "/contract-service-fees",
    component: "ContractServiceFees"
  }
)

@Component()
export default class ContractServiceFees extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "ContractServiceFees.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('integro_api/list_contract_service_fee', {
      parameters: () => ({ ...this.dsParams, date: this.$fn.today() })
    })
  }

  gridName!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'dsParams', 'ds', 'gridName', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        dsParams: {
          skip_archived: true,
        }
        ,
        ds: null,
        gridName: "contractServiceFees",
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "contract_revision",
          name: this.$fn.pgettext("Contract", "Contract number"),
          params: {
            sortPath: "contract_revision.contract_number",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_revision.contract_number",
                source: "row",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              skipExport: true,
              params: {
                id: "contract_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_type",
          field: "contract_revision",
          name: this.$fn.pgettext("Contracts", "Type"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_type",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractTypes",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "inputValue",
              variantmap: {
                rental: "contract-type--rental",
                vendor: "contract-type--vendor",
                rental_agreement: "contract-type--rental_agreement",
                service: "contract-type--service",
                parking: "contract-type--parking",
                unknown: "contract-type--unknown",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_status",
          field: "contract_revision",
          name: this.$fn.pgettext("Contracts", "Status"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "status",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractStatus",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "fieldValue",
              variantmap: {
                draft: "light",
                approved: "success",
                signed: "success",
                active: "primary",
                ended: "warning",
                terminated: "warning",
                rescinded: "danger",
                archived: "light",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental",
          name: this.$fn.pgettext("ContractServiceFees", "Rental"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
    {{~#if $value.house_number }} | {{ $value.house_number }}{{/if }}\n\
    {{~#if $value.area }} ({{$value.area}}{{$value.unit_of_area}}){{/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "rental_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("Contract", "Company"),
          params: {
            sortPath: "company.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "counterparty",
          name: this.$fn.pgettext("Contract", "Counterparty"),
          params: {
            sortPath: "counterparty.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "counterparty.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "valid_from",
          name: this.$fn.pgettext("Contracts", "Valid From"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "valid_to",
          name: this.$fn.pgettext("Contracts", "Valid To"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "next_indexation_date",
          name: this.$fn.pgettext("Contracts", "Next Indexation Date"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("ContractService", "Name"),
          type: "command",
        }
          ,
        {
          field: "amount",
          name: this.$fn.pgettext("ContractService", "Amount"),
          type: "command",
          textAlign: "right",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if amount }}\n\
    {{ number amount }} {{ currency }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "billable_amount",
          name: this.$fn.pgettext("ContractService", "Total"),
          type: "command",
          textAlign: "right",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if amount }}\n\
    {{ number billable_amount }} {{ currency }}\n\
    {{~#if (neq currency billing_currency) }}\n\
      (→ {{ billing_currency }})\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "clicksink",
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "unit",
          name: this.$fn.pgettext("ContractServiceFee", "Unit"),
        }
          ,
        {
          field: "quantity",
          name: this.$fn.pgettext("ContractService", "Quantity"),
          type: "command",
          textAlign: "right",
          formatter: {
            name: "template",
            engine: "hb",
            format: "<span>\n\
  {{~#if quantity }}\n\
    {{ number quantity }} {{ unit_of_quantity }}\n\
  {{~/if }}\n\
</span>\n\
",
          }
          ,
        }
          ,
        {
          field: "inflation_indexed",
          name: this.$fn.pgettext("ContractService", "Inflation indexed"),
          formatter: "checkbox",
        }
          ,
        {
          field: "transaction_notes",
          name: this.$fn.pgettext("ContractService", "Invoice notes"),
          formatter: {
            name: "join",
            separator: ", ",
          }
          ,
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("ContractService", "Billing category"),
        }
          ,
        {
          field: "invoice_group_id",
          name: this.$fn.pgettext("ContractService", "Invoice group"),
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("ContractService", "Description"),
        }
          ,
        {
          field: "intermediated_service",
          name: this.$fn.pgettext("ContractService", "Intermediated service"),
          formatter: "checkbox",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Contract service fees"),
        icon: this.$config.contract.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7348_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7348, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_7350_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_7350, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_7352_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7352, alias=undefined
    return {
      name: "ContractService",
      props: {
        modal: true,
        oid: $event.data.data.contract_service_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7351_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7351, alias=undefined
    return $event.data.column.id === 'name'
  }

  async act_2248226175642056_showModal_7354_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7354, alias=undefined
    return {
      name: "ContractServiceFee",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7353_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7353, alias=undefined
    return $event.data.column.id === 'billable_amount'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_4440454779651433_reloadSlickgrid_7358_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4440454779651433_reloadSlickgrid_7358, alias=reload
    return {
      grid: this.gridName,
    }
  }

  async evh_4440454779651433_close_7357_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_4440454779651433_close_7357, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_4440454779651433_showModal_7356_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4440454779651433_showModal_7356, alias=undefined
    return {
      name: "BulkContractServiceFeeEditor",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_4440454779651433_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4440454779651433_click.executeFromDOM(this, event, scope);
  }

  async act_8643180786190723_reloadSlickgrid_7362_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8643180786190723_reloadSlickgrid_7362, alias=reload
    return {
      grid: this.gridName,
    }
  }

  async act_8643180786190723_request_7360_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8643180786190723_request_7360, alias=bulkDelete
    return {
      operation: "bulk_delete_contract_service_fee",
      data: { items: _.map(this.selectedItems, p => _.pick(p, ['id', 'etag'])) },
    }
  }

  async evh_8643180786190723_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8643180786190723_click.executeFromDOM(this, event, scope);
  }

  async act_2996188254223402_reloadSlickgrid_7366_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2996188254223402_reloadSlickgrid_7366, alias=reload
    return {
      grid: this.gridName,
    }
  }

  async evh_2996188254223402_close_7365_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2996188254223402_close_7365, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_2996188254223402_showModal_7364_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2996188254223402_showModal_7364, alias=undefined
    return {
      name: "BulkIndexContractServiceFee",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_2996188254223402_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2996188254223402_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7348: actions.CloseModalAction;
    evh_7315092382398562_close_7347: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_7350: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_7349: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_7352: actions.ShowModalAction;
    evh_2248226175642056_command_7351: actions.EventHandlerImpl;
    act_2248226175642056_showModal_7354: actions.ShowModalAction;
    evh_2248226175642056_command_7353: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_4440454779651433_reloadSlickgrid_7358: actions.ReloadSlickgridAction;
    evh_4440454779651433_close_7357: actions.EventHandlerImpl;
    act_4440454779651433_showModal_7356: actions.ShowModalAction;
    evh_4440454779651433_click_7355: actions.EventHandlerImpl;
    evh_4440454779651433_click: actions.EventHandlerGroup;
    act_8643180786190723_reloadSlickgrid_7362: actions.ReloadSlickgridAction;
    evh_8643180786190723_success_7361: actions.EventHandlerImpl;
    act_8643180786190723_request_7360: actions.RequestAction;
    evh_8643180786190723_click_7359: actions.EventHandlerImpl;
    evh_8643180786190723_click: actions.EventHandlerGroup;
    act_2996188254223402_reloadSlickgrid_7366: actions.ReloadSlickgridAction;
    evh_2996188254223402_close_7365: actions.EventHandlerImpl;
    act_2996188254223402_showModal_7364: actions.ShowModalAction;
    evh_2996188254223402_click_7363: actions.EventHandlerImpl;
    evh_2996188254223402_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7348 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7348_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7347 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7348,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7347],
      }
    );
    const act_2248226175642056_setData_7350 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_7350_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_7349 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_7350,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_7349],
      }
    );
    const act_2248226175642056_showModal_7352 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7352_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7351 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7352,
        event: "command",
        when: this.evh_2248226175642056_command_7351_getWhen,
        displayName: "showModal",
      }
    );
    const act_2248226175642056_showModal_7354 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7354_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7353 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7354,
        event: "command",
        when: this.evh_2248226175642056_command_7353_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_7351, evh_2248226175642056_command_7353],
      }
    );
    const act_4440454779651433_reloadSlickgrid_7358 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4440454779651433_reloadSlickgrid_7358_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_4440454779651433_close_7357 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_reloadSlickgrid_7358,
        event: "close",
        when: this.evh_4440454779651433_close_7357_getWhen,
        displayName: "reload",
      }
    );
    const act_4440454779651433_showModal_7356 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4440454779651433_showModal_7356_getActionArgs,
        events: [evh_4440454779651433_close_7357],
      }
    );
    const evh_4440454779651433_click_7355 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_showModal_7356,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_4440454779651433_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4440454779651433_click_7355],
      }
    );
    const act_8643180786190723_reloadSlickgrid_7362 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8643180786190723_reloadSlickgrid_7362_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_8643180786190723_success_7361 = new actions.EventHandlerImpl(
      {
        action: act_8643180786190723_reloadSlickgrid_7362,
        event: "success",
        displayName: "reload",
      }
    );
    const act_8643180786190723_request_7360 = new actions.RequestAction(
      {
        actionArgs: this.act_8643180786190723_request_7360_getActionArgs,
        displayName: "bulkDelete",
        events: [evh_8643180786190723_success_7361],
      }
    );
    const evh_8643180786190723_click_7359 = new actions.EventHandlerImpl(
      {
        action: act_8643180786190723_request_7360,
        event: "click",
        displayName: "bulkDelete",
      }
    );
    const evh_8643180786190723_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8643180786190723_click_7359],
      }
    );
    const act_2996188254223402_reloadSlickgrid_7366 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2996188254223402_reloadSlickgrid_7366_getActionArgs,
        displayName: "reload",
        events: [],
      }
    );
    const evh_2996188254223402_close_7365 = new actions.EventHandlerImpl(
      {
        action: act_2996188254223402_reloadSlickgrid_7366,
        event: "close",
        when: this.evh_2996188254223402_close_7365_getWhen,
        displayName: "reload",
      }
    );
    const act_2996188254223402_showModal_7364 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2996188254223402_showModal_7364_getActionArgs,
        events: [evh_2996188254223402_close_7365],
      }
    );
    const evh_2996188254223402_click_7363 = new actions.EventHandlerImpl(
      {
        action: act_2996188254223402_showModal_7364,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_2996188254223402_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_2996188254223402_click_7363],
      }
    );
    return {
      act_7315092382398562_closeModal_7348,
      evh_7315092382398562_close_7347,
      evh_7315092382398562_close,
      act_2248226175642056_setData_7350,
      evh_2248226175642056_selectedRowsChanged_7349,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_7352,
      evh_2248226175642056_command_7351,
      act_2248226175642056_showModal_7354,
      evh_2248226175642056_command_7353,
      evh_2248226175642056_command,
      act_4440454779651433_reloadSlickgrid_7358,
      evh_4440454779651433_close_7357,
      act_4440454779651433_showModal_7356,
      evh_4440454779651433_click_7355,
      evh_4440454779651433_click,
      act_8643180786190723_reloadSlickgrid_7362,
      evh_8643180786190723_success_7361,
      act_8643180786190723_request_7360,
      evh_8643180786190723_click_7359,
      evh_8643180786190723_click,
      act_2996188254223402_reloadSlickgrid_7366,
      evh_2996188254223402_close_7365,
      act_2996188254223402_showModal_7364,
      evh_2996188254223402_click_7363,
      evh_2996188254223402_click,
      reload: act_2996188254223402_reloadSlickgrid_7366,
      bulkDelete: act_8643180786190723_request_7360,
    }
  }
}

Vue.component("ContractServiceFees", ContractServiceFees);

</script>